<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName">
				<FormItem prop="trackName">
					<Input style="width: 260px;" type="text" v-model="formInline.OperatorId" placeholder="社会信用代码">
					<span slot="prepend">运营商Id</span>
					</Input>
				</FormItem>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
			<div style="float: right;">
				<Button type="primary" @click="show('add')" v-if="hasWidgets('add')">运营商添加</Button>
				<!-- <Button style="float: left;margin-left: 5px;" type="primary" @click="show('addExcel')">批量导入</Button> -->
			</div>
		</Form>
		<Table :columns="columns1" :data="data1" :height="tableHeight"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getOperatorInfoUrl" @listData='getDeviceData'></MyPage>
		<Modal @on-cancel="cancelPictures" :mask-closable="false" v-model="modalView" :title="modal.Title" width="60%">
			<!--安装和修改-->
			<Form label-position="right" :rules="ruleInline"
				v-if="modal.type=='add'||modal.type=='update'||modal.type=='view'" ref="AddUpForm" :model="StationForm"
				:label-width="120">
				<Row>
					<Col span=7>
					<FormItem class="seflPoing" label="运营商ID" prop="OperatorId">
						<Input :disabled="ifup" v-model="StationForm.OperatorId" placeholder="输入运营商ID"></Input>
					</FormItem>
					</Col>
					<Col span=15 style="margin-left: 2%;">
					<!-- <FormItem label="场站Id" prop="Id">
						<Input v-model="StationForm.Id" placeholder="输入设备编号"></Input>
					</FormItem> -->
					<FormItem label="平台logo" prop="StationCode">
						<div class="demo-upload-list" :key="item.uid" v-for="item in uploadList">
							<template v-if="item.status === 'finished'">
								<img :src="item.url">
								<div class="demo-upload-list-cover">
									<Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
									<Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
								</div>
							</template>
							<template v-else>
								<Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
							</template>
						</div>
						<Upload ref="upload" :headers="upHeader" :show-upload-list="false"
							:default-file-list="defaultList" :on-success="handleSuccess" name="UpFile"
							:format="['jpg','jpeg','png']" :max-size="2048" :on-format-error="handleFormatError"
							:on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" multiple type="drag"
							:action="uploadImageUrl" style="display: inline-block;width:58px;">
							<div style="width: 58px;height:58px;line-height: 58px;">
								<Icon type="ios-camera" size="20"></Icon>
							</div>
						</Upload>
						<Modal title="View Image" v-model="visible">
							<img :src="imgName" v-if="visible" style="width: 100%">
						</Modal>
					</FormItem>
					</Col>
				</Row>
				<Row style="margin-bottom: 10px;">
					<Col span=7>
					<FormItem label="运营商类型" prop="Type">
						<Select :disabled="ifViewStation" placeholder="运营商类型" v-model="StationForm.Type">
							<Option :value='1'>场站运营商</Option>
							<Option :value='2'>设备生产商</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem label="运营商名称" prop="OperatorName">
						<Input :disabled="ifViewStation" v-model="StationForm.OperatorName"
							placeholder="输入运营商名称"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem label="是否启用" prop="Enable">
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0'
							v-model="StationForm.Enable" size="large">
							<span slot="open">是</span>
							<span slot="close">否</span>
						</i-switch>
					</FormItem>
					</Col>
				</Row>
				<Row style="margin-bottom: 10px;">
					<!-- <Col span=7>
					<FormItem label="关联的收款商户" prop="MerchantId">
						<Input :disabled="ifViewStation" v-model="StationForm.MerchantId" placeholder="输入关联的收款商户"></Input>
					</FormItem>
					</Col> -->
					<Col span=7>
					<FormItem label="运营商电话1" prop="OperatorTel1">
						<Input :disabled="ifViewStation" v-model="StationForm.OperatorTel1"
							placeholder="输入运营商电话1"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem label="运营商电话2" prop="OperatorTel2">
						<Input :disabled="ifViewStation" v-model="StationForm.OperatorTel2"
							placeholder="输入运营商电话2"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span=7>
					<FormItem label="域名列表" prop="DomainName">
						<Input :disabled="ifViewStation" v-model="StationForm.DomainName" placeholder="输入域名列表"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem label="ICP备案信息" prop="IcpNo">
						<Input :disabled="ifViewStation" v-model="StationForm.IcpNo" placeholder="输入ICP备案信息"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem label="平台显示标题" prop="LogoTitle">
						<Input :disabled="ifViewStation" v-model="StationForm.LogoTitle" placeholder="输入平台显示标题"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col span=7>
					<FormItem label="运营商注册地址" prop="OperatorRgeAddress">
						<Input :disabled="ifViewStation" v-model="StationForm.OperatorRgeAddress"
							placeholder="输入运营商注册地址"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem label="备注" prop="Remark">
						<Input :disabled="ifViewStation" v-model="StationForm.Remark" placeholder="输入备注"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem label="公司简称" prop="ShortName">
						<Input :disabled="ifViewStation" v-model="StationForm.ShortName" placeholder="输入公司简称"></Input>
					</FormItem>
					</Col>
				</Row>
				<!-- <Row style="margin-left: 2%;">
					<Col span=24>
					<FormItem label="支付方式" prop="PaymentMode">
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="PayMethod1"
							size="large">
							<span slot="open">离线卡</span>
							<span slot="close">离线卡</span>
						</i-switch>
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="PayMethod2"
							size="large" style="margin-left: 15%;">
							<span slot="open">在线卡</span>
							<span slot="close">在线卡</span>
						</i-switch>
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="PayMethod3"
							size="large" style="margin-left: 15%;">
							<span slot="open">支付宝</span>
							<span slot="close">支付宝</span>
						</i-switch>
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0' v-model="PayMethod4"
							size="large" style="margin-left: 15%;">
							<span slot="open">微信</span>
							<span slot="close">微信</span>
						</i-switch>
					</FormItem>
					</Col>
				</Row> -->
				<!-- <Row>
					<Col span=7>
					<FormItem label="建档人Id" prop="CreateBy">
						<Input :disabled="ifAddStation" v-model="StationForm.CreateBy" placeholder="建档人Id"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem label="建档人" prop="Creator">
						<Input :disabled="ifAddStation" v-model="StationForm.Creator" placeholder="建档人"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem label="建档时间" prop="CreateTime">
						<Input :disabled="ifAddStation" v-model="StationForm.CreateTime" placeholder="建档时间"></Input>
					</FormItem>
					</Col>
				</Row> -->
				<!-- <Row>
					<Col span=7>
					<FormItem label="修改人Id" prop="ModifyBy">
						<Input :disabled="ifAddStation" v-model="StationForm.ModifyBy" placeholder="修改人Id"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem label="修改人" prop="Modifier">
						<Input :disabled="ifAddStation" v-model="StationForm.Modifier" placeholder="修改人"></Input>
					</FormItem>
					</Col>
					<Col span=7>
					<FormItem label="修改时间" prop="ModifyTime">
						<Input :disabled="ifAddStation" v-model="StationForm.ModifyTime" placeholder="修改时间"></Input>
					</FormItem>
					</Col>
				</Row> -->
			</Form>
			<div v-if="modal.type=='add'" slot="footer">
				<Button v-if="modal.type!='install'" type="warning" size="large" @click="modalCancel">重置</Button>
				<Button type="success" size="large" @click="modalOk('add')">新增</Button>
			</div>
			<div v-if="modal.type=='update'" slot="footer">
				<Button type="success" size="large" @click="modalOk('up')">确认修改</Button>
			</div>
			<div v-if="modal.type=='view'" slot="footer">
			</div>
		</Modal>
		<Modal :z-index="zindex" v-model="showMap" :title="modal.Title" width="40%">
			<div id="map" style="width: 100%;height: 300px;"></div>
			<div slot="footer">
				<Button type="success" size="small" @click="closeMap">关闭</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js'
	export default {
		data() {
			const validateOpId = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('输入运营商Id'));
				} else {
					if (this.StationForm.OperatorId.length < 9) {
						callback(new Error('社会信用代码不少于9位'));
					} else if (this.StationForm.OperatorId.length > 20) {
						callback(new Error('社会信用代码不多于20位'));
					} else {
						callback();
					}
				}
			};
			return {
				getOperatorInfoUrl: webapi.base_api_url + '/Archives/GetOperatorInfo',
				uploadImageUrl: webapi.base_api_url + '/Common/UploadImage',
				zindex: 2000,
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				// //选择展示的充电站
				// SelectStation: "有家充电站",
				tableHeight: "650",
				modal: {
					Title: "运营商添加",
					type: "addOperator"
				},
				//修改添加moda
				modalView: false,
				//图片modal
				showPictures: false,
				//图片上传组件数据
				defaultList: [],
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				imgName: '',
				visible: false,
				uploadList: [],
				//新增图片删除缓存
				PictureDelCache: [],
				//原始图片删除缓存
				PictureUpCache: [],
				//图片地址数组
				StationPicturesArray: [],
				/******分割线********/

				//地图modal
				center: [114.198595, 22.633595],
				showMap: false,

				//字段显示
				ifAddStation: true,

				//修改不能修改id
				ifup: false,
				//场站信息是否只能查看
				ifViewStation: false,
				//档案-场站管理全部信息
				StationForm: {
					"OperatorId": "",
					"Type": 99,
					"OperatorName": "",
					"Enable": 0,
					"MerchantId": 0,
					"PaymentMode": 0,
					"OperatorTel1": "",
					"OperatorTel2": "",
					"OperatorRgeAddress": "",
					"Remark": "",
					"CreateBy": 0,
					"CreateTime": "2022-03-13T08:29:55.002Z",
					"ModifyBy": 0,
					"ModifyTime": "2022-03-13T08:29:55.002Z",
					"LogoTitle": "",
					"LogoImg": "",
					"ShortName": "",
					"IcpNo": "",
					"DomainName": "",
					"Creator": "",
					"Modifier": "",
					"IsEdit": false
				},
				//校验字段
				ruleInline: {
					OperatorId: [{
						validator: validateOpId,
						trigger: 'blur',
					}],
					Type: [{
						required: true,
						message: '运营商类型',
						trigger: 'change',
						type: 'number'
					}],
					OperatorName: [{
						required: true,
						message: '运营商名称',
						trigger: 'blur'
					}],
					OperatorTel1: [{
						required: true,
						message: '运营商电话1',
						trigger: 'blur'
					}],
					LogoTitle: [{
						required: true,
						message: '平台显示标题',
						trigger: 'blur'
					}]
					// DomainName: [{
					// 	required: true,
					// 	message: '域名',
					// }],
				},
				BreadcrumbList: ['档案管理', '>>', '运营商管理'],
				formInline: {
					OperatorId: ''
				},
				//table标题数据
				columns1: [{
						title: '运营商ID',
						key: 'OperatorId',
						width: 120
					}, {
						title: '运营商名称',
						key: 'OperatorName',
						width: 200
					},
					{
						title: '运营商电话1',
						key: 'OperatorTel1',
						width: 120
					},
					{
						title: '运营商电话2',
						key: 'OperatorTel2',
						width: 120
					},
					{
						title: '平台显示标题',
						key: 'LogoTitle',
						width: 200
					},
					{
						title: '平台显示logo图片',
						key: 'LogoImg',
						width: 200,
						render: (h, params) => {
							let url = ''
							// if (process.env.NODE_ENV === "development") {
							// 	url = 'http://'+window.location.href.split("/")[2]+'/ChargePlatform'+(params.row.LogoImg.split(","))[0];
							// }else {
							//   url = 'https://'+window.location.href.split("/")[2]+'/ChargePlatform'+(params.row.LogoImg.split(","))[0];
							// }
							url = webapi.base_api_url + (params.row.LogoImg.split(","))[0];
							let arr = [];
							if (params.row.LogoImg == "" || params.row.LogoImg == undefined) {
								arr.push(
									h('div', "未上传"))
							} else {
								arr.push(
									h('div', [
										h('img', {
											style: {
												width: "40px",
												height: "40px",
												verticalAlign: "middle",
												borderRadius: "50%"
											},
											attrs: {
												src: url
												//src: "ChargePlatform/"+(params.row.LogoImg.split(","))[0]
											}
										})
									])
								)
							}
							return arr;
							// return h('div',
							// 	params.row.LogoImg
							// );
						}
					},
					{
						title: 'ICP备案信息',
						key: 'IcpNo',
						width: 200
					},
					{
						title: '域名列表',
						key: 'DomainName',
						width: 300
					}, {
						title: '操作',
						key: 'action',
						minWidth: 130,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('edit') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("update", params.row.OperatorId)
										}
									}
								}, '修改') : h(),
								this.hasWidgets('view') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										//为了不误操作，确定取消相反
										click: () => {
											this.show("view", params.row.OperatorId)
										}
										// this.show("deleteStation", params.row.Id)
									}
								}, '查看') : h(),
								// h('Dropdown', {
								// 		on: {
								// 			//为了不误操作，确定取消相反
								// 			'on-click': (name) => {
								// 				this.$Modal.confirm({
								// 					title: name,
								// 					okText: '取消',
								// 					cancelText: '确定',
								// 					onCancel: () => {
								// 						this.otherMethodStation(name, params.row.Id);
								// 					}
								// 				});
								// 				// this.show("deleteStation", params.row.Id)
								// 			}
								// 		}
								// 	},
								// 	[
								// 		h('Button', {
								// 			props: {
								// 				type: 'primary',
								// 				size: 'small',
								// 			},
								// 			style: {
								// 				marginRight: '5px'
								// 			},
								// 		}, '其他操作'),
								// 		h('DropdownMenu', {
								// 			slot: 'list'
								// 		}, [
								// 			this.methodList.map((item) => { // this.productTypeList下拉框里的data
								// 				return h('DropdownItem', {
								// 						props: {
								// 							name: item.Status
								// 						}
								// 					},
								// 					item.Status
								// 				)
								// 			})
								// 		])
								// 	],
								// )
							]);
						}
					}
				],
				methodList: [{
						id: 1,
						Status: '建设中'
					}, {
						id: 5,
						Status: '关闭下线'
					},
					{
						id: 6,
						Status: '维护中'
					},
					{
						id: 50,
						Status: '正常使用'
					}
				],
				data1: [],
				payValue: 0
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
			//this.uploadList = this.$refs.upload.fileList;
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					OperatorId: _this.formInline.OperatorId
				}
				return param
			},
			PayMethod1: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					console.log(pay)
					console.log(pay.substring(5, 6))
					return Number(pay.substring(5, 6))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 1;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 1;
					}
				}
			},
			PayMethod2: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					return Number(pay.substring(4, 5))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 2;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 2;
					}
				}
			},
			PayMethod3: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					return Number(pay.substring(1, 2))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 16;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 16;
					}
				}
			},
			PayMethod4: {
				get() {
					let pay = this.StationForm.PaymentMode.toString(2);
					while (pay.length < 6) {
						pay = '0' + pay;
					}
					return Number(pay.substring(0, 1))
				},
				set(value) {
					if (value == 0) {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode - 32;
					} else {
						this.StationForm.PaymentMode = this.StationForm.PaymentMode + 32;
					}
				}
			},
			//直接选属性
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			...mapActions([
				'GetTypeListDefine',
			]),
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//操作
			show: function(type, params) {
				switch (type) {
					case "add":
						this.modal.type = "add";
						this.modal.Title = "运营商添加";
						this.ifup = false
						this.ifViewStation = false
						this.modalCancel();
						break;
					case "update":
						this.modal.type = "update";
						this.modal.Title = "运营商添加信息修改";
						this.ifup = true
						this.$nextTick(() => {
							this.getUpdateMessage(params);
						})
						this.ifViewStation = false
						break;
					case "view":
						this.modal.type = "view";
						this.modal.Title = "运营商信息查看";
						this.$nextTick(() => {
							this.getUpdateMessage(params);
						})
						this.ifViewStation = true
						this.ifup = true
						break;
				}
				this.modalView = true;
			},
			//modal取消操作
			cancelPictures: function() {
				const _this = this
				_this.PictureUpCache = []
				if (_this.PictureDelCache.length > 0) {
					console.log("取消添加或更新modal，删除添加的缓存图片")
					let picsArr = _this.PictureDelCache
					let StationPictures = ''
					for (let i = 0; i < picsArr.length; i++) {
						if (i == (picsArr.length - 1)) {
							StationPictures += picsArr[i]
						} else {
							StationPictures += picsArr[i] + ','
						}
					}
					_this.deletePicture(StationPictures)
				}
			},
			//删除修改之外的其他操作
			otherMethodStation: function(name, Id) {
				let typeNum = (this.methodList.filter(function(item, index, arr) {
					return item.Status == name
				})[0]).id
				console.log(typeNum)
				this.$axios.post(webapi.base_api_url + "/Archives/SetStationStatus2222", {
					Id: Id,
					Status: typeNum
				}).then(res => {
					if (res.data.code == 0) {
						this.$Message.info(name + '成功');
					}
				})
			},
			deleteStation: function() {
				const _this = this;
				_this.$axios.post(webapi.base_api_url + "/Overview/###", {}).then(res => {
					if (res.data.code != 1 && res.data.Data != null) {
						this.$Message.info('删除成功');
					}
				})
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},
			modalCancel: function() {
				this.uploadList = []
				this.StationPicturesArray = []
				this.$nextTick(() => {
					this.$refs.AddUpForm.resetFields();
					console.log(this.$refs.AddUpForm);
					this.$refs.upload.clearFiles();
					this.defaultList = this.$refs.upload.fileList
				})
			},
			getUpdateMessage: function(OperatorId) {
				console.log("修改查看运营商方法OperatorId" + OperatorId);
				const _this = this;
				for (let i = 0; i < _this.data1.length; i++) {
					if (_this.data1[i].OperatorId == OperatorId) {
						_this.StationForm = Object.assign({}, _this.data1[i])
						_this.StationPicturesArray = [];
						let PictureStr = _this.data1[i].LogoImg;
						let picList = []
						if (PictureStr != "") {
							_this.StationPicturesArray = PictureStr.split(",")
							for (let i = 0; i < _this.StationPicturesArray.length; i++) {
								let url = ''
								// if (process.env.NODE_ENV === "development") {
								// 	url = 'http://'+window.location.href.split("/")[2]+'/ChargePlatform'+_this.StationPicturesArray[i];
								// }else {
								//   url = 'https://'+window.location.href.split("/")[2]+'/ChargePlatform'+_this.StationPicturesArray[i];
								// }
								url = webapi.base_api_url + _this.StationPicturesArray[i];
								let picture = {
									name: _this.StationPicturesArray[i],
									url: url
								}
								picList.push(picture)
							}
						}
						_this.defaultList = picList
						_this.$nextTick(() => {
							// dom元素更新后执行，因此这里能正确打印更改之后的值
							_this.uploadList = _this.$refs.upload.fileList
						})
					}
				}
			},
			//新增||修改
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case "add":
						_this.StationForm.IsEdit = false
						break;
					case "up":
						_this.StationForm.IsEdit = true
						let picsArr = _this.PictureUpCache
						if (picsArr.length > 0) {
							let StationPictures = ''
							for (let i = 0; i < picsArr.length; i++) {
								if (i == (picsArr.length - 1)) {
									StationPictures += picsArr[i]
								} else {
									StationPictures += picsArr[i] + ','
								}
							}
							_this.deletePicture(StationPictures)
						}
						break;
				}
				_this.PictureDelCache = [];
				_this.PictureUpCache = [];
				let picsArr = _this.StationPicturesArray
				_this.StationForm.LogoImg = ''
				for (let i = 0; i < picsArr.length; i++) {
					if (i == (picsArr.length - 1)) {
						_this.StationForm.LogoImg += picsArr[i]
					} else {
						_this.StationForm.LogoImg += picsArr[i] + ','
					}
				}
				const param = _this.StationForm
				_this.$refs.AddUpForm.validate((valid) => {
					console.log("场站" + type + "----" + valid)
					if (valid) {
						_this.$axios.post(webapi.base_api_url + '/Archives/AddOperator',
							param
						).then(res => {
							console.log(res)
							if (res.data.Code == 0) {
								_this.$Message.success("运营商" + type + "成功");
								_this.$refs.sonPage.getList();
								_this.modalView = false;
								_this.PictureDelCache = [];
								_this.GetTypeListDefine()
							} else {
								_this.$Message.error("运营商" + type + "失败:" + res.data.Data);
							}
						})
					}
				})
			},
			//地图modal
			mapOpen: function() {
				this.showMap = true;
				gaodeMap.initMap("map", 10, this.center, 'normal');
				gaodeMap.mapOn2(this);
			},
			closeMap: function() {
				gaodeMap.map.destroy();
				gaodeMap.map = '';
				this.showMap = false;
			},
			deletePicture: function(pictureStr) {
				const _this = this
				_this.$axios.post(webapi.base_api_url + "/Common/DeleteImage", {
					FilePath: pictureStr
				}).then(res => {
					if (res.data.Code == 0) {
						_this.$Message.success('删除成功');
						_this.PictureDelCache = []
						_this.handleSubmit()
					} else {
						_this.$Message.error('图片删除失败');
						_this.handleSubmit()
					}
				})
			},
			/**********图片组件方法*************/
			handleView(name) {
				this.imgName = name;
				this.visible = true;
			},
			handleRemove(file) {
				console.log(file)
				const _this = this
				if (_this.PictureDelCache.indexOf(file.name) > 0) {
					console.log('删除缓存中存在')

				} else {
					console.log('删除缓存中不存在，是原有图片删除')
					_this.PictureUpCache.push(file.name)
				}
				const fileList = _this.$refs.upload.fileList;
				_this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				_this.$nextTick(() => {
					// dom元素更新后执行，因此这里能正确打印更改之后的值
					_this.uploadList = _this.$refs.upload.fileList
					_this.defaultList = _this.$refs.upload.fileList
				})
				_this.StationPicturesArray = _this.StationPicturesArray.filter(function(item, index,
					arr) {
					console.log(file.name)
					return item != file.name
				})
			},
			handleSuccess(res, file) {
				if (res.Code == 0) {
					// if (process.env.NODE_ENV === "development") {
					// 	file.url = 'http://'+window.location.href.split("/")[2]+'/ChargePlatform'+res.Data;
					// }else {
					//   file.url = 'https://'+window.location.href.split("/")[2]+'/ChargePlatform'+res.Data;
					// }
					file.url = webapi.base_api_url + res.Data.List[0];
					file.name = res.Data.List[0];
					let itemLen = this.defaultList.length;
					this.$set(this.defaultList, itemLen, file);
					this.uploadList = this.defaultList
					this.StationPicturesArray.push(file.name)
					this.PictureDelCache.push(file.name)
				}
				//file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar';
				//file.name = '7eb99afb9d5f317c912f08b5212fd69a';
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: '格式错误',
					desc: '请选择 jpg or png.'
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: '图片太大',
					desc: '文件' + file.name + ' 图片太大请选择小于 2M.'
				});
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 5;
				if (!check) {
					this.$Notice.warning({
						title: 'Up to five pictures can be uploaded.'
					});
				}
				return check;
			},
			OperatorNameChange: function(a) {
				console.log(a)
				this.StationForm.OperatorId = a;
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}

	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}

	.seflPoing .ivu-form-item-label:before {
		content: '*';
		display: inline-block;
		margin-right: 4px;
		line-height: 1;
		font-family: SimSun;
		font-size: 12px;
		color: #ed4014;
	}
</style>
